import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About", id: "about" },
  { to: "/insights", label: "Insights", id: "insights" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-nav" className="fixed inset-x-0 top-0 z-50 border-b border-border bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
        <Link to="/" data-testid="nav-brand" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/logo-mark.png" alt="Heartland Physics logo" className="h-9 w-9 rounded-md object-contain" />
          <span className="font-heading text-sm font-extrabold tracking-[0.18em] text-ink">
            HEARTLAND PHYSICS
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.id}
              to={l.to}
              data-testid={`nav-link-${l.id}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-blueprint" : "text-ink/70 hover:text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/request"
            data-testid="nav-cta-request"
            className="group flex items-center gap-1.5 bg-blueprint px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-ink"
          >
            Request Shielding Design
            <ArrowUpRight size={15} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="grid h-10 w-10 place-items-center border border-border text-ink md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-border bg-white md:hidden">
          <div className="flex flex-col px-5 py-4">
            {LINKS.map((l) => (
              <NavLink
                key={l.id}
                to={l.to}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `border-b border-border py-4 text-sm font-medium ${isActive ? "text-blueprint" : "text-ink"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/request"
              data-testid="nav-mobile-cta-request"
              onClick={() => setOpen(false)}
              className="mt-4 flex items-center justify-center gap-2 bg-blueprint px-5 py-3 text-sm font-semibold text-white"
            >
              Request Shielding Design <ArrowUpRight size={15} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
